import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import { GaTrackingEventName, GATrackingEventType } from '../../constants';

export class GATrackingMiniCartInteractionEvent implements GATrackingEvent {
  constructor(private payload: any){}

  getEventType(): GATrackingEventType {
    return this.payload.type;
  }

  getPayload(): GATrackingEventPayload {
    return {
      event: GaTrackingEventName.MiniCart,
      label: this.payload.label,
      gtmCustom: {
        category: this.payload.category
      }
    };
  }
}
